import type { AirtimeNetwork } from '@/types/airtime';

export interface AirtimeNetworkMeta {
  id: AirtimeNetwork;
  label: string;
  logo: string;
  ring: string;
}

export const AIRTIME_NETWORKS: AirtimeNetworkMeta[] = [
  {
    id: 'MTN',
    label: 'MTN',
    logo: '/networks/mtn.png',
    ring: 'ring-yellow-400',
  },
  {
    id: 'AIRTEL',
    label: 'Airtel',
    logo: '/networks/airtel.png',
    ring: 'ring-red-400',
  },
  {
    id: 'GLO',
    label: 'Glo',
    logo: '/networks/glo.jpg',
    ring: 'ring-green-500',
  },
  {
    id: '9MOBILE',
    label: '9mobile',
    logo: '/networks/9mobile.png',
    ring: 'ring-emerald-600',
  },
];

export const AIRTIME_NETWORK_MAP = Object.fromEntries(
  AIRTIME_NETWORKS.map((network) => [network.id, network]),
) as Record<AirtimeNetwork, AirtimeNetworkMeta>;

export const AIRTIME_AMOUNT_PRESETS = [50, 100, 200, 500, 1000, 2000] as const;

export const AIRTIME_PHONE_PREFIXES: Record<AirtimeNetwork, string[]> = {
  MTN: ['0803', '0806', '0703', '0706', '0813', '0816', '0810', '0814', '0903', '0906', '0913', '0916'],
  AIRTEL: ['0802', '0808', '0708', '0812', '0701', '0902', '0907', '0901', '0912'],
  GLO: ['0805', '0807', '0705', '0815', '0811', '0905', '0915'],
  '9MOBILE': ['0809', '0817', '0818', '0909', '0908'],
};

export function detectAirtimeNetwork(phone: string): AirtimeNetwork | null {
  const digits = phone.replace(/\D/g, '');
  const normalized = digits.length === 11 ? digits : digits.length === 10 ? `0${digits}` : '';
  if (normalized.length !== 11) return null;
  const prefix = normalized.slice(0, 4);
  for (const network of AIRTIME_NETWORKS) {
    if (AIRTIME_PHONE_PREFIXES[network.id].includes(prefix)) return network.id;
  }
  return null;
}

export function getAirtimeNetworkMeta(network: AirtimeNetwork): AirtimeNetworkMeta {
  return AIRTIME_NETWORK_MAP[network];
}
